import { render, staticRenderFns } from "./currencySettings.vue?vue&type=template&id=14546dfc&scoped=true&"
import script from "./currencySettings.vue?vue&type=script&lang=js&"
export * from "./currencySettings.vue?vue&type=script&lang=js&"
import style0 from "./currencySettings.vue?vue&type=style&index=0&id=14546dfc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14546dfc",
  null
  
)

export default component.exports